export const environment = {
    production: false,
    baseUrl: 'https://gateway-t.erp-devapi.com/',
    apiUrl: 'https://gateway-t.erp-devapi.com/',
    aiBaseUrl: "https://tenant-py.erp-devapi.com/",
    aiCourseFinderUrl: "https://aicoursefinder.erp-devapi.com/",
    tenantUrl: 'https://tenant-chat.erp-devapi.com/chat/',
    chatSocketUrl: 'https://tenant-chat.erp-devapi.com',
    companyId: 't_47d9cc274a08a0cabfda7431',
    imageBaseUrl: "https://visionway-dev-assets.s3.ap-south-1.amazonaws.com/",
    videoMeetUrl: "https://temp-fastapi.erp-devapi.com/api/",
    firebase: {
        apiKey: "AIzaSyCZZpZCORoJWuIrglmW9RcZXqMd7kb1lnQ",
        authDomain: "vision-way.firebaseapp.com",
        projectId: "vision-way",
        storageBucket: "vision-way.firebasestorage.app",
        messagingSenderId: "1016463848472",
        appId: "1:1016463848472:web:90d4178cb52b578e983f6d",
        measurementId: "G-XZDH7SFCM6",
        vapidKey: "BA90OQGyzqo9GtAU77dWbplqZL2VVxor3iAlPq84713LlsmCvztgtLnakMmMJeGa6_nJXF-Da3kDjA8w9oT6ktU"
    }
};
